import { render } from "./SimpleNoteCreateBottomSection.vue?vue&type=template&id=7f21ddfb"
import script from "./SimpleNoteCreateBottomSection.vue?vue&type=script&lang=js"
export * from "./SimpleNoteCreateBottomSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__